import { LazyRouteDefinition, createRouteViewSwitch } from '../../util-routing'
import { ScreenerQuery, ScreenerViewType } from './types'

const viewParamParser = (param: string | null) =>
  // if the param is not provided, we should render Overview
  (param || ScreenerViewType.Overview).slice(0, 2) as ScreenerViewType

// const sharedRoot: ObjectRoute = {
//   LazyComponent: () => import(/* webpackChunkName: "screener-shared-component" */ './components/ScreenerSharedRoot'),
// }

const { loader, action, lazySwitch } = createRouteViewSwitch<string, ScreenerViewType>({
  skipNotFound: true,
  defaultView: ScreenerViewType.Overview,
  viewParam: ScreenerQuery.View,
  viewParamParser,
  views: {
    // Table pages
    // [ScreenerViewType.Overview]: sharedRoot,
    // [ScreenerViewType.Valuation]: sharedRoot,
    // [ScreenerViewType.Ownership]: sharedRoot,
    // [ScreenerViewType.Performance]: sharedRoot,
    [ScreenerViewType.Custom]: {
      LazyComponent: () =>
        import(/* webpackChunkName: "screener-shared-component" */ './components/CustomizeButtonRoot'),
    },
    // [ScreenerViewType.Financial]: sharedRoot,
    // [ScreenerViewType.Technical]: sharedRoot,
    // [ScreenerViewType.ETF]: sharedRoot,
    // [ScreenerViewType.ETFPerf]: sharedRoot,

    // Non-table pages
    // [ScreenerViewType.Charts]: sharedRoot,
    // [ScreenerViewType.Basic]: sharedRoot,
    // [ScreenerViewType.News]: sharedRoot,
    // [ScreenerViewType.Snapshot]: sharedRoot,
    // [ScreenerViewType.TA]: sharedRoot,
    // [ScreenerViewType.Tickers]: sharedRoot,
    // [ScreenerViewType.Stats]: sharedRoot,

    // This route has own #root
    // [ScreenerViewType.Maps]: sharedRoot,
  },
})

export const screenerModule: LazyRouteDefinition[] = [
  {
    path: '/screener.ashx',
    loader,
    action,
    lazy: lazySwitch,
  },
]
